// extracted by mini-css-extract-plugin
module.exports = {"header":"ExplainerSection_header__fKTCx","video":"ExplainerSection_video__rMvFb"};